import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=79d0e4e6&scoped=true&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"
import style0 from "./Theme.vue?vue&type=style&index=0&id=79d0e4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d0e4e6",
  null
  
)

export default component.exports